import * as React from "react"
import { Box, Container, Link as MuiLink } from "@mui/material"

export default function DashboardFooter() {
  return (
    <Container maxWidth="1480px">
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "flex-start", md: "center" },
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          fontSize: "sm",
          color: "gray.400",
          paddingTop: 4,
          paddingBottom: { xs: 6, sm: 4, md: 2 },
        }}
      >
        <Box>
          © 2022 Luz Data · All Rights Reserved · logos provided by{" "}
          <MuiLink
            sx={{ color: "gray.400", textDecoration: "none" }}
            href="https://clearbit.com"
          >
            Clearbit
          </MuiLink>
        </Box>
        <Box>
          <MuiLink
            sx={{ color: "gray.400", textDecoration: "none" }}
            href="https://luzdata.crunch.help"
            target="_blank"
          >
            Help Center
          </MuiLink>{" "}
          ·{" "}
          <MuiLink
            sx={{ color: "gray.400", textDecoration: "none" }}
            href="mailto:support@luzdata.com"
          >
            Support
          </MuiLink>
        </Box>
      </Box>
    </Container>
  )
}
